export const questions = [
  {
    number: 1,
    score: 5,
    type: "cr",
    question: "What is 1 + 1 - 1?",
    answer: "2",
    knowledgePoints: ["addition", "subtraction"],
    pValue: 99,
    averageTime: 3,
    hint: " add then substract",
    marked: "",
    process: "untouched", //started, finished
  },
  {
    number: 2,
    type: "cr",
    score: 5,
    question: "What is 10 x 15?",
    answer: "1500",
    knowledgePoints: ["multiplicaton"],
    pValue: 60,
    averageTime: 3,
    hint: "move zero from 10",
    marked: "",
    process: "untouched",
  },

  {
    number: 3,
    type: "mc",
    score: 5,
    question: "Who is the first president of United States?",
    choices: [
      "A. Donald Trump",
      "B. Zedong Mao",
      "C. George Washington",
      "D. Barack Obama",
    ],
    answer: "George Washington",
    knowledgePoints: ["American History I"],
    pValue: 80,
    averageTime: 1,
    hint: "The oldest one",
    marked: "",
    process: "untouched",
  },

  {
    number: 4,
    type: "lg",
    score: 5,
    question:
      "The struggle to obtain legal recognition of aboriginal rights is a difficult one, and even if a right is written into the law there is no guarantee that the future will not bring changes to the law that undermines the right. For this reason, the federal government of Canada in 1982 extended constitutional protection to those aboriginal rights already recognized under the law. This protection was extended to the Indian, Inuit, and Métis peoples, the three groups generally thought to comprise the aboriginal population in Canada. But this decision has placed on provincial courts the enormous burden of interpreting and translating the necessarily general constitutional language into specific rulings. The result has been inconsistent recognition and establishment of aboriginal rights, despite the continued efforts of aboriginal peoples to raise issues concerning their rights.",
    answer: "1500",
    knowledgePoints: ["reading5", "writing5"],
    pValue: 60,
    averageTime: 3,
    hint: "move zero from 10",
    marked: "",
    process: "untouched",
  },
];

// export default questions；
